import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './ServicesPage.css';

const WHATSAPP_NUMBER = '905403041414';
const DEFAULT_SERVICE_AREAS = ['Yıldırım Mah', 'Kocatepe Mah', 'Kartaltepe Mah', 'Muratpaşa Mah'];

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [serviceAreas, setServiceAreas] = useState(DEFAULT_SERVICE_AREAS);
  const [loading, setLoading] = useState(true);

  const handleTeklifAl = (serviceTitle) => {
    const message = `Merhaba, ${serviceTitle} hizmeti için teklif almak istiyorum.`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank');
  };

  useEffect(() => {
    const servicesRef = ref(database, 'services');
    const unsubscribe = onValue(servicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const servicesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setServices(servicesList);
      } else {
        setServices([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const contactRef = ref(database, 'contactInfo');
    const unsubscribe = onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data && Array.isArray(data.serviceAreas) && data.serviceAreas.length > 0) {
        setServiceAreas(data.serviceAreas);
      } else {
        setServiceAreas(DEFAULT_SERVICE_AREAS);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="services-page">
      <div className="page-hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/elektrik9.jpeg)` }}>
        <div className="container">
          <h1 className="page-hero-title">Hizmetlerimiz</h1>
          <p className="page-hero-areas-label">Hizmet verdiğimiz semtler</p>
          <div className="page-hero-areas-list">
            {serviceAreas.map((area) => (
              <span key={area} className="page-hero-area-pill">{area}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="services-page-content">
        <div className="container">
          {loading ? (
            <div className="services-loading">
              <p>Hizmetler yükleniyor...</p>
            </div>
          ) : services.length === 0 ? (
            <div className="services-empty">
              <p>Henüz hizmet eklenmemiş.</p>
            </div>
          ) : (
            <div className="services-grid">
              {services.map((service, index) => (
                <div key={service.id || index} className="service-card">
                  {service.image && (
                    <div className="service-card-image-wrap">
                      <img src={service.image} alt={service.title} className="service-card-image" />
                    </div>
                  )}
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                  <button type="button" className="service-teklif-btn" onClick={() => handleTeklifAl(service.title)}>
                    Teklif Al
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
